var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackstatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.632,
    height: 80,
    viewBox: "0 0 68.632 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Track_status",
    "data-name": "Track status",
    transform: "translate(-26.7 -18.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M45.6,62.039V92.021H95.46V98.7H39V62.039Zm53.2-43.268V85.414H92.2V25.379h-20V18.7h26.6Z",
    transform: "translate(-3.462 0)",
    fill: "#12355f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_1_",
    d: "M81.814,79.291v6.754h-6.9V79.291Zm-13.581-.144v6.9H47.969v-6.9ZM81.814,65.854v6.754h-6.9V65.854Zm-13.581-.072v6.754H51.347V65.782Zm0-13.365v7.257H54.652V52.417Zm13.581-.072V59.1h-6.9V52.345ZM56.377,20.8l5.533,3.808-21.916,31.4L26.7,45.59l4.168-5.317,7.689,6.036ZM81.67,38.764v7.114H74.915V38.764H81.67Zm-13.437.216v6.754H57.814V38.98Z",
    transform: "translate(0 -0.591)",
    fill: "#f48a21",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackstatus);
export default __webpack_public_path__ + "static/media/Track status.19d97ec23abd59d217283abda9d51317.svg";
export { ForwardRef as ReactComponent };